<template>
  <view-more-text-box :line-clamp="lineClamp" textBoxClasses="text-body-2 text-grey-body">{{ bio }}</view-more-text-box>
</template>

<script lang="ts">
import ViewMoreTextBox from '@/components/view_more_text_box/ViewMoreTextBox.vue';

export default {
  name: 'ProfileBio',
  components: { ViewMoreTextBox },
  props: {
    bio: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    isMobile() {
      return this.windowWidth < 640;
    },
    lineClamp(): number {
      return this.isMobile ? 8 : 5;
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.updateScreenSize);
    });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateScreenSize);
  },
  methods: {
    updateScreenSize() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>
